import React, { SVGProps } from "react";

const SvgRoof6 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 300" {...props}>
    <defs>
      <linearGradient
        id="roof6_svg__a"
        x1={68.706}
        y1={218.83}
        x2={109.885}
        y2={147.506}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.316} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
    </defs>
    <path fill="none" d="M0 0h350v300H0z" />
    <g data-name="roof029 dims 1">
      <path
        fill="#b4c5d3"
        d="M130.612 215.109v39.325L309.601 150.98v-39.325L130.612 215.109z"
      />
      <path
        fill="url(#roof6_svg__a)"
        d="M130.612 215.109v39.325L28.51 195.622v-49.999l45.892-18.603 56.21 88.089z"
      />
      <g fill="#6d9faf">
        <path d="M78.334 149.501v10.3l-8.563-4.933v-10.3l8.563 4.933zM88.824 155.557v10.3l-8.563-4.933v-10.299l8.563 4.932zM78.334 161.836v10.3l-8.563-4.932v-10.3l8.563 4.932zM88.824 167.893v10.299l-8.563-4.932v-10.3l8.563 4.933z" />
      </g>
      <path
        fill="#237cae"
        d="M319.907 105.564 130.612 215.109l-56.728-87.807L263.594 17.84l56.313 87.724z"
      />
      <path
        fill="#47d6ff"
        d="M263.594 17.84 73.884 127.302l-55.8 22.573L207.64 40.322l55.954-22.482z"
      />
      <path
        fill="#b4c5d3"
        d="M183.014 146.145v18.842l66.638-38.588v-13.536l-31.805-13.747-34.833 47.029z"
      />
      <path
        fill="#dae5f0"
        d="M183.014 149.988v14.999l-6.978-10.062 6.978-4.937z"
      />
      <path
        fill="#46dfff"
        d="m168.895 152.599 12.573 7.253 37.576-58.608-49.921-28.892-.228 80.247z"
      />
      <path
        fill="#255d63"
        d="M204.1 131.837v12.857l10.949-6.34v-12.857l-10.949 6.34zM217.341 124.193v12.856l10.948-6.339v-12.857l-10.948 6.34z"
      />
      <path
        fill="none"
        stroke="#3f3f3f"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="m228.605 197.794-97.993 56.64L28.51 195.622v-49.999M295.2 159.303l-55.878 32.299M309.601 111.655v39.325l-4.042 2.337"
      />
      <path
        fill="none"
        stroke="#3f3f3f"
        strokeMiterlimit={10}
        d="M130.612 215.109v39.325"
      />
      <path
        fill="none"
        stroke="#002839"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m205.937 171.521 55.324-32.021M271.131 133.793l48.776-28.229-56.313-87.724-55.954 22.482L18.084 149.875l55.8-22.573 56.728 87.807 62.949-36.431"
      />
      <path
        fill="none"
        stroke="#002839"
        strokeMiterlimit={10}
        d="M74.269 126.596 263.594 17.84"
      />
      <path
        fill="none"
        stroke="#3f3f3f"
        strokeMiterlimit={10}
        d="M249.652 113.329v13.07l-66.638 38.588-4.904-7.072M183.014 164.833v-7.505"
      />
      <path
        fill="#206e9c"
        d="m242.925 108.414 12.572 7.253-36.453-14.423-49.921-28.892 73.802 36.062z"
      />
      <path
        fill="none"
        stroke="#002839"
        strokeLinejoin="round"
        d="m169.123 72.352 49.921 28.892-37.576 58.608-12.573-7.253.228-80.247z"
      />
      <path
        fill="none"
        stroke="#002839"
        strokeLinejoin="round"
        d="m169.123 72.352 73.802 36.062 12.572 7.253-36.453-14.423"
      />
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m108.734 267.397 16.75-9.682M7.286 208.943l16.71-9.718M11.538 206.681l101.014 58.203" />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="M168.245 276.102 136.01 257.48M347.202 172.898l-32.195-18.658M342.722 170.768l-178.14 102.731" />
      </g>
      <g fill="none" stroke="#fff" strokeLinejoin="round" opacity={0.5}>
        <path d="M183.016 152.361v-2" />
        <path strokeDasharray="3.59645 3.59645" d="M183.016 146.764v-26.973" />
        <path d="M183.016 117.993v-2" />
      </g>
      <text
        transform="translate(258.525 232.621)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"B"}
      </text>
      <text
        transform="translate(53.286 249.808)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"A"}
      </text>
      <path
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M343.069 167.053v6.926M164.187 270.193v6.926M112.877 261.645v6.925M11.341 203.093v6.926"
      />
      <text
        transform="translate(14.835 124.649)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"P1"}
      </text>
      <path
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M68.602 124.869 4.659 87.94M10.204 87.389l-6.581 3.8M23.752 144.803l-1.719 7.403M22.975 148.485c-10.03-19.46-15.97-40.468-16.025-59.233"
      />
      <text
        transform="translate(262.353 102.518)"
        fontSize={16}
        fill="#fff"
        fontFamily="'Effra Regular', Effra"
      >
        {"P2"}
      </text>
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="m266.58 77.742-6.581-3.8M252.328 111.192l.91 7.545"
      />
      <path
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="m249.898 204.042-61.831-35.709M316.7 165.591l-61.791-35.745M312.672 163.721l-66.197 38.102"
      />
      <text
        transform="translate(280.865 193.697)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"C"}
      </text>
      <path
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M313.019 160.007v6.926M246.292 198.394v6.926"
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="m152.516 139.066 27.397-15.829M107.183 107.94l49.298 28.345"
      />
      <text
        transform="translate(121.305 135.375)"
        fontSize={16}
        fill="#fff"
        fontFamily="'Effra Regular', Effra"
      >
        {"D"}
      </text>
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M156.659 133.313v6.926M107.238 104.497v6.926"
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinejoin="round"
        strokeDasharray={4}
        opacity={0.5}
        d="m133.765 92.796 52.415 30.145"
      />
      <path
        d="M252.77 114.55c6.536-12.736 10.41-26.466 10.464-38.745M267.246 73.506l-45.009 25.869"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      />
    </g>
  </svg>
);

export default SvgRoof6;
